import { Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { pickAFileSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";

const BusinessRulesViewer = () => {
    const businessRules = useSelector((state: any) => state.pickAFile.businessRules);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    const onBusinessRulesChange = (event: any) => {
        dispatch({ type: pickAFileSliceDispatch.setBusinessRules, payload: event.target.value });
        CreateContentsFromStates({ businessRules: event.target.value });
    }

    const formDetails =
        <Form.Item>
            <label>Business Rules</label>
            <TextArea id="businessRules" placeholder='Add a memo....' defaultValue={businessRules} onBlur={onBusinessRulesChange} />
        </Form.Item>

    return formDetails;
}

export default BusinessRulesViewer;